import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { JournalEntryModel } from '@shared/data-access/models';
import { filter, Observable, take } from 'rxjs';
import { JournalEntryAction } from '../actions';
import { JournalEntryReducer } from '../reducers';
import { JournalEntrySelector } from '../selectors';

@Injectable()
export class JournalEntryFacade {
  selectedItem$ = this._store.select(JournalEntrySelector.selectJournalEntry);
  constructor(private _store: Store<JournalEntryReducer.JournalEntryState>) {}

  /**
   * Get @JournalEntryModel by id
   */
  getById(id: number): Observable<JournalEntryModel | null> {
    this._store.dispatch(JournalEntryAction.loadItem({ id }));
    return this.selectedItem$.pipe(
      filter(val => !!val && val.id === id),
      take(1)
    ) as Observable<JournalEntryModel | null>;
  }
}
